import { cn, Label } from "@workspace/frontend-ui";

type Props = SelectProps & {
  children: React.ReactNode;
  name?: string;
  label: string;
  ref?: React.ForwardedRef<HTMLSelectElement>;
  placeholder?: string;
  error?: boolean;
};

const CustomSelect: React.FC<Props> = ({ children, ...props }) => (
  <div className="flex flex-col w-full h-full justify-between">
    <Label className="text-muted-foreground text-base font-normal mb-2 w-full">
      {props.label}
    </Label>
    <select
      {...props}
      className={cn(
        "h-10 px-2 text-muted-foreground border cursor-pointer border-border bg-secondary hover:border-white duration-200 ease-in-out delay-0 rounded-lg max-w-90",
        props.error && "border-primary",
      )}
    >
      {children}
    </select>
  </div>
);

export default CustomSelect;
